import { DEFAULT_LANG } from '@rover/shared/js/constants/i18n/language';
import getDateTimeFormatForLang from './datetimeContextless';

export const defaultDateTimeFormatMap = getDateTimeFormatForLang(DEFAULT_LANG);
export { default, getExternalFormatMap, I18N_FORMAT_MAP } from './datetimeContextless';



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/index.js